import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentRegion, setIsShowGeolocationBlock } from '~/src/redux/geolocation/geolocation.slice';
import { resetPopupContentAction } from '~/src/redux/popups/popups.slice';
import { selectCurrentRegion } from '~/src/redux/geolocation/geolocation.selectors';
import { SvgClose } from '~/src/components/svg-components/close';
import { COLORS } from '~/src/styles/tokens/colors';
import type { RegionsDataInterface } from '~/src/repositories/regions/regions.repository';
import type { CustomInputChangeInterface } from '~/src/components/form-components/dropdown/dropdown.types';
import * as Styled from './geolocation-modal-content.styles';

interface GeolocationModalContentProps {
    onCloseClick: () => void;
    regionsData: RegionsDataInterface[] | [];
}

export const GeolocationModalContent: FC<GeolocationModalContentProps> = ({ onCloseClick, regionsData }) => {
    const dispatch = useDispatch();
    const currentRegion = useSelector(selectCurrentRegion);
    const [newCurrentRegion, setNewRegionData] = useState(currentRegion);

    const handleSelectCurrentRegion = (data: CustomInputChangeInterface) => {
        setNewRegionData({ id: Number(data?.id), name: data?.suggestValue });
    };

    const handleSetCurrentRegion = () => {
        dispatch(setCurrentRegion(newCurrentRegion));
        dispatch(resetPopupContentAction());
        dispatch(setIsShowGeolocationBlock(false));
    };

    return (
        <Styled.GeolocationModalContentWrapper>
            <Styled.GeolocationModalContentHeader>
                <Styled.GeolocationModalContentTitle>Выберите ваше местоположение</Styled.GeolocationModalContentTitle>
                <Styled.IconContainer>
                    <Styled.SvgWrapper onClick={onCloseClick}>
                        <SvgClose color={COLORS.iconLightPrimary} />
                    </Styled.SvgWrapper>
                </Styled.IconContainer>
            </Styled.GeolocationModalContentHeader>
            <Styled.GeolocationModalContentSubTitle>
                В зависимости от региона условия тарифов могут&nbsp;меняться
            </Styled.GeolocationModalContentSubTitle>
            <Styled.RegionFieldWrapper
                label={'Регион'}
                onSuggestedValueChange={handleSelectCurrentRegion}
                regionsData={regionsData}
                name={'regionId'}
                withoutSuggest={false}
                value={currentRegion?.name}
                withOptionsDisplayIcon
                autocompleteWithSelect
            />
            <Styled.MainButtonWrapper onClick={handleSetCurrentRegion}>Выбрать</Styled.MainButtonWrapper>
        </Styled.GeolocationModalContentWrapper>
    );
};
